import { TrendingUp, TrendingDown } from 'lucide-react'

interface ChangeIndicatorProps {
  value: number | null
  /** Show trend icon (TrendingUp/Down). Default: false for grid usage. */
  showIcon?: boolean
  /** Number of fraction digits. Default: 1. */
  fractionDigits?: number
}

/**
 * Displays a change value with green (positive) / red (negative) / gray (zero/null) coloring.
 * Reference implementation from Totalstatistikk.
 */
export default function ChangeIndicator({ value, showIcon = false, fractionDigits = 1 }: ChangeIndicatorProps) {
  if (value === null || value === undefined) return <span className="text-gray-400">—</span>
  if (value > 0) {
    return (
      <span className="text-green-600 dark:text-green-400 inline-flex items-center gap-0.5">
        {showIcon && <TrendingUp className="w-3.5 h-3.5" />}
        {value.toLocaleString('nb-NO', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits })}
      </span>
    )
  }
  if (value < 0) {
    return (
      <span className="text-red-600 dark:text-red-400 inline-flex items-center gap-0.5">
        {showIcon && <TrendingDown className="w-3.5 h-3.5" />}
        {value.toLocaleString('nb-NO', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits })}
      </span>
    )
  }
  return <span className="text-gray-500">{(0).toLocaleString('nb-NO', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits })}</span>
}

interface ChangeCountProps {
  value: number
}

/**
 * Displays a count change with +/- prefix and green/red coloring.
 */
export function ChangeCount({ value }: ChangeCountProps) {
  if (value > 0) {
    return <span className="text-green-600 dark:text-green-400">{value.toLocaleString('nb-NO')}</span>
  }
  if (value < 0) {
    return <span className="text-red-600 dark:text-red-400">{'\u2212'}{Math.abs(value).toLocaleString('nb-NO')}</span>
  }
  return <span className="text-gray-500">0</span>
}
